/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["preview-container{display:flex;width:100%;min-height:100%;align-items:center;justify-content:center;position:relative;overflow:hidden}preview-container>*{position:absolute;top:0;left:0;right:0;bottom:0;margin:auto}"];
export { styles as styles };
